import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import Main from 'src/components/Dashboard/Views/Main.vue'
import Posts from 'src/components/Dashboard/Views/Posts.vue'
import Educations from 'src/components/Dashboard/Views/Educations.vue'
import News from 'src/components/Dashboard/Views/News.vue'
import Races from 'src/components/Dashboard/Views/Races.vue'
import LeaderArticles from 'src/components/Dashboard/Views/LeaderArticles.vue'
import AddLeaderArticles from 'src/components/Dashboard/Views/PostModules/LeaderArticles/Add.vue'
import EditLeaderArticles from 'src/components/Dashboard/Views/PostModules/LeaderArticles/Edit.vue'
import Announcements from 'src/components/Dashboard/Views/Announcements.vue'
import AddAnnouncements from 'src/components/Dashboard/Views/PostModules/Announcements/Add.vue'
import EditAnnouncements from 'src/components/Dashboard/Views/PostModules/Announcements/Edit.vue'
import ActivityProgram from 'src/components/Dashboard/Views/ActivityProgram.vue'
import AddActivityProgram from 'src/components/Dashboard/Views/PostModules/ActivityProgram/Add.vue'
import EditActivityProgram from 'src/components/Dashboard/Views/PostModules/ActivityProgram/Edit.vue'
import DigitalPress from 'src/components/Dashboard/Views/DigitalPress.vue'
import AddDigitalPress from 'src/components/Dashboard/Views/PostModules/DigitalPress/Add.vue'
import EditDigitalPress from 'src/components/Dashboard/Views/PostModules/DigitalPress/Edit.vue'
import Allnews from 'src/components/Dashboard/Views/Allnews.vue'
import RaceLogs from 'src/components/Dashboard/Views/RaceLogs.vue'
import RaceApplications from 'src/components/Dashboard/Views/RaceApplications.vue'
import RaceApplicationsInspect from 'src/components/Dashboard/Views/RaceModules/Inspect.vue'
import RaceApplicationsEdit from 'src/components/Dashboard/Views/RaceModules/Edit.vue'
import ComingFromYou from 'src/components/Dashboard/Views/ComingFromYou.vue'
import Archives from 'src/components/Dashboard/Views/Archives.vue'
import StaticPages from 'src/components/Dashboard/Views/StaticPages.vue'
import JobPostings from 'src/components/Dashboard/Views/JobPostings.vue'
import Categories from 'src/components/Dashboard/Views/Categories.vue'
import RaceCategories from 'src/components/Dashboard/Views/RaceCategories.vue'
import Newcategories from 'src/components/Dashboard/Views/Newcategories.vue'
import Menus from 'src/components/Dashboard/Views/Menus.vue'
import Feedbacks from 'src/components/Dashboard/Views/Feedbacks.vue'
import Newsletter from 'src/components/Dashboard/Views/Newsletter.vue'
import Scores from 'src/components/Dashboard/Views/Scores.vue'
import Users from 'src/components/Dashboard/Views/Users.vue'
import Settings from 'src/components/Dashboard/Views/Settings.vue'
import Leader from 'src/components/Dashboard/Views/Leader.vue'
import History from 'src/components/Dashboard/Views/History.vue'
import ActivityProgramContent from 'src/components/Dashboard/Views/ActivityProgramContent.vue'
import ComingFromYouContent from 'src/components/Dashboard/Views/ComingFromYouContent.vue'
import IntroVideo from 'src/components/Dashboard/Views/IntroVideo.vue'
import InformationBanksContent from 'src/components/Dashboard/Views/InformationBanksContent.vue'
import Ads from 'src/components/Dashboard/Views/Ads.vue'
import Slider from 'src/components/Dashboard/Views/Slider.vue'
import Directors from 'src/components/Dashboard/Views/Directors.vue'
import AllLeaders from 'src/components/Dashboard/Views/AllLeaders.vue'
import ProvincialOffices from 'src/components/Dashboard/Views/ProvincialOffices.vue'
import MainStatusInstructions from 'src/components/Dashboard/Views/MainStatusInstructions.vue'
import SubBoards from 'src/components/Dashboard/Views/SubBoards.vue'
import Staffs from 'src/components/Dashboard/Views/Staffs.vue'
import Members from 'src/components/Dashboard/Views/Members.vue'
import Comments from 'src/components/Dashboard/Views/Comment.vue'
import Dictionary from 'src/components/Dashboard/Views/Dictionary.vue'
import Reports from 'src/components/Dashboard/Views/Reports.vue'
import SearchUser from 'src/components/Dashboard/Views/MemberModules/Search.vue'
import JobPostingAddEdit from 'src/components/Dashboard/Views/JobPostingModules/add-edit.vue'
import NewSubscriber from 'src/components/Dashboard/Views/NewsletterModules/NewSubscriber.vue'
import SendBulkEmail from 'src/components/Dashboard/Views/NewsletterModules/SendBulk.vue'
import AddPage from 'src/components/Dashboard/Views/PostModules/Pages/Add.vue'
import AddEducation from 'src/components/Dashboard/Views/PostModules/Education/Add.vue'
import AddNews from 'src/components/Dashboard/Views/PostModules/News/Add.vue'
import AddRaces from 'src/components/Dashboard/Views/PostModules/Races/Add.vue'
import AddAllnews from 'src/components/Dashboard/Views/PostModules/Allnews/Add.vue'
import AddEditCategory from 'src/components/Dashboard/Views/CategoryModules/AddEdit.vue'
import AddEditRaceCategory from 'src/components/Dashboard/Views/RaceCategoryModules/AddEdit.vue'
import AddEditNewcategory from 'src/components/Dashboard/Views/NewcategoryModules/AddEdit.vue'
import SubBoardsCategories from 'src/components/Dashboard/Views/SubBoardsCategories.vue'
import AddEditSubBoardCategories from 'src/components/Dashboard/Views/SubBoardCategoriesModules/AddEdit.vue'
import AddEditUser from 'src/components/Dashboard/Views/UserModules/AddEdit.vue'
import MemberAthletes from 'src/components/Dashboard/Views/MemberModules/MemberAthletes.vue'
import AddStaticPage from 'src/components/Dashboard/Views/StaticPageModules/SubModules/Add.vue'
import EditStaticPage from 'src/components/Dashboard/Views/StaticPageModules/SubModules/Edit.vue'
import EditPage from 'src/components/Dashboard/Views/PostModules/Pages/Edit.vue'
import EditNews from 'src/components/Dashboard/Views/PostModules/News/Edit.vue'
import EditRaces from 'src/components/Dashboard/Views/PostModules/Races/Edit.vue'
import EditAllnews from 'src/components/Dashboard/Views/PostModules/Allnews/Edit.vue'
import EditComingFromYou from 'src/components/Dashboard/Views/PostModules/ComingFromYou/Edit.vue'
import EditNewsGallery from 'src/components/Dashboard/Views/NewGalleryModules/Index.vue'
import EditLeaderGallery from 'src/components/Dashboard/Views/LeaderGalleryModules/Index.vue'
import EditPressGallery from 'src/components/Dashboard/Views/PressGalleryModules/Index.vue'
import EditGallery from 'src/components/Dashboard/Views/GalleryModules/Index.vue'
import EditVideoGallery from 'src/components/Dashboard/Views/VideoGalleryModules/Index.vue'
import EditAllnewsGallery from 'src/components/Dashboard/Views/AllnewGalleryModules/Index.vue'
import EditAllnewsPdf from 'src/components/Dashboard/Views/AllnewsPdfsModules/AllnewsPdfs.vue'
import EditNewsPdf from 'src/components/Dashboard/Views/NewsPdfsModules/NewsPdfs.vue'
import EditLeaderPdf from 'src/components/Dashboard/Views/LeaderPdfsModules/LeaderPdfs.vue'
import EditDigitalPressPdf from 'src/components/Dashboard/Views/DigitalPressPdfsModules/DigitalPressPdfs.vue'
import EditNewsSlider from 'src/components/Dashboard/Views/NewSliderModules/Index.vue'
import EditAllnewsSlider from 'src/components/Dashboard/Views/AllnewSliderModules/Index.vue'
import EditDigitalPressSlider from 'src/components/Dashboard/Views/DigitalPressSliderModules/Index.vue'
import EditLeaderArticlesSlider from 'src/components/Dashboard/Views/LeaderArticlesSliderModules/Index.vue'
import EditLeaderArticlesGallery from 'src/components/Dashboard/Views/LeaderArticlesGalleryModules/Index.vue'
import EditDigitalPressGallery from 'src/components/Dashboard/Views/DigitalPressGalleryModules/Index.vue'
import EditEducation from 'src/components/Dashboard/Views/PostModules/Education/Edit.vue'
import EditArchive from 'src/components/Dashboard/Views/PostModules/ArchiveModules/EditArchive.vue'
import Permission from 'src/components/Dashboard/Views/UserModules/Permissions.vue'
import Featured from 'src/components/Dashboard/Views/FeaturedModules/Featured.vue'
import ArticlesOrder from 'src/components/Dashboard/Views/ArticlesOrderModules/ArticlesOrder.vue'
import AllnewsOrder from 'src/components/Dashboard/Views/AllnewsOrderModules/AllnewsOrder.vue'
import NewsOrder from 'src/components/Dashboard/Views/NewsOrderModules/NewsOrder.vue'
import DigitalPressOrder from 'src/components/Dashboard/Views/DigitalPressOrderModules/DigitalPressOrder.vue'
import Facilities from 'src/components/Dashboard/Views/Facilities.vue'
import Editfacilities from 'src/components/Dashboard/Views/PostModules/Facilities/Edit.vue'
import Addfacilities from 'src/components/Dashboard/Views/PostModules/Facilities/Add.vue'
import BankInformations from 'src/components/Dashboard/Views/BankInformations.vue'
import EditBankInformations from 'src/components/Dashboard/Views/PostModules/BankInformations/Edit.vue'
import AddBankInformations from 'src/components/Dashboard/Views/PostModules/BankInformations/Add.vue'
import Homeboxes from 'src/components/Dashboard/Views/Homeboxes.vue'
import ActivityProgramPage from 'src/components/Dashboard/Views/ActivityProgramPage.vue'
import EditActivityProgramPage from 'src/components/Dashboard/Views/PostModules/ActivityProgramPage/Edit.vue'
import AddActivityProgramPage from 'src/components/Dashboard/Views/PostModules/ActivityProgramPage/Add.vue'
import CupPointPage from 'src/components/Dashboard/Views/CupPointPage.vue'
import EditCupPointPage from 'src/components/Dashboard/Views/PostModules/CupPointPage/Edit.vue'
import AddCupPointPage from 'src/components/Dashboard/Views/PostModules/CupPointPage/Add.vue'
import InformationBanksPage from 'src/components/Dashboard/Views/InformationBanksPage.vue'
import EditInformationBanksPage from 'src/components/Dashboard/Views/PostModules/InformationBanksPage/Edit.vue'
import AddInformationBanksPage from 'src/components/Dashboard/Views/PostModules/InformationBanksPage/Add.vue'
import Edithomeboxes from 'src/components/Dashboard/Views/PostModules/Homeboxes/Edit.vue'
import Addhomeboxes from 'src/components/Dashboard/Views/PostModules/Homeboxes/Add.vue'
import HomeInfos from 'src/components/Dashboard/Views/HomeInfos.vue'
import EditHomeInfos from 'src/components/Dashboard/Views/PostModules/HomeInfos/Edit.vue'
import AddHomeInfos from 'src/components/Dashboard/Views/PostModules/HomeInfos/Add.vue'

const routes = [{
        path: '/',
        component: DashboardLayout,
        redirect: '/main'
    },
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/main',
        children: [{
                path: 'statistics',
                name: 'statistics',
                component: Main
            },
            {
                path: 'ads',
                name: 'Reklam Yönetimi',
                component: Ads
            },
            {
                path: 'featured',
                name: 'Vitrin',
                component: Featured
            },
            {
                path: '/leader/articlesorder',
                name: 'Yazıları Sırala',
                component: ArticlesOrder
            },
            {
                path: '/allnews-order',
                name: 'Haberleri Sırala',
                component: AllnewsOrder
            },
            {
                path: '/news-order',
                name: 'Bildirileri Sırala',
                component: NewsOrder
            },
            {
                path: '/leader/digital-press-order',
                name: 'Yayınları Sırala',
                component: DigitalPressOrder
            },
            {
                path: 'dictionary',
                name: 'Sözlük',
                component: Dictionary
            },
            {
                path: 'main1',
                name: 'main1',
                component: Posts
            },
            {
                path: '/user/permissions/:id',
                name: 'Permission',
                component: Permission
            },
            {
                path: '/main',
                name: 'Slider',
                component: Slider
            },
            {
                path: '/directors',
                name: 'Directors',
                component: Directors
            },
            {
                path: '/all-leaders',
                name: 'AllLeaders',
                component: AllLeaders
            },
            {
                path: '/provincial-offices',
                name: 'ProvincialOffices',
                component: ProvincialOffices
            },
            {
                path: '/main-status-instructions',
                name: 'MainStatusInstructions',
                component: MainStatusInstructions
            },
            {
                path: '/sub-boards',
                name: 'SubBoards',
                component: SubBoards
            },
            {
                path: '/staffs',
                name: 'Staffs',
                component: Staffs
            },
            {
                path: 'settings',
                name: 'Ayarlar',
                component: Settings
            },
            {
                path: 'leader',
                name: 'Başkanın Bölümü',
                component: Leader
            },
            {
                path: 'history',
                name: 'Tarihçe',
                component: History
            },
            {
                path: 'activity-program-content',
                name: 'Activity Program Content',
                component: ActivityProgramContent
            },
            {
                path: 'coming-from-you-content',
                name: 'Coming From You Content',
                component: ComingFromYouContent
            },
            {
                path: 'intro-video',
                name: 'Intro Video',
                component: IntroVideo
            },
            {
                path: 'information-banks-content',
                name: 'Information Banks Content',
                component: InformationBanksContent
            },
            {
                path: 'homeboxes',
                name: 'Anasayfa Kutular',
                component: Homeboxes
            },
            {
                path: 'homeinfos',
                name: 'Anasayfa Bilgiler',
                component: HomeInfos
            },
            {
                path: '/bank-informations',
                name: 'Hesap Numaraları',
                component: BankInformations
            },
            {
                path: 'comments',
                name: 'Yorumlar',
                component: Comments
            },
            {
                path: 'reports',
                name: 'Şikayetler',
                component: Reports
            },
            {
                path: 'search-user',
                name: 'Üye Ara',
                component: SearchUser
            },
            {
                path: 'news',
                name: 'News',
                component: News
            },
            {
                path: 'races',
                name: 'Races',
                component: Races
            },
            {
                path: 'allnews',
                name: 'Allnews',
                component: Allnews
            },
            {
                path: 'coming-from-you',
                name: 'ComingFromYou',
                component: ComingFromYou
            },
            {
                path: 'educations',
                name: 'educations',
                component: Educations
            },
            {
                path: 'archive',
                name: 'archive',
                component: Archives
            },
            {
                path: 'static-pages',
                name: 'Static Pages',
                component: StaticPages
            },
            {
                path: 'job-postings',
                name: 'Job Postings',
                component: JobPostings
            },
            {
                path: 'categories',
                name: 'Categories',
                component: Categories
            },
            {
                path: 'seasons',
                name: 'Seasons',
                component: RaceCategories
            },
            {
                path: 'newcategories',
                name: 'Newcategories',
                component: Newcategories
            },
            {
                path: '/sub-board-categories',
                name: 'SubBoardsCategories',
                component: SubBoardsCategories
            },
            {
                path: 'menus',
                name: 'menu',
                component: Menus
            },
            {
                path: 'feedbacks',
                name: 'Feedbacks',
                component: Feedbacks
            },
            {
                path: 'newsletter',
                name: 'Newsletter',
                component: Newsletter
            },
            {
                path: '/page/add',
                name: 'AddPage',
                component: AddPage
            },
            {
                path: '/page/add',
                name: 'Add Page',
                component: AddPage
            },
            {
                path: '/news/add',
                name: 'Add News',
                component: AddNews
            },
            {
                path: '/races/add',
                name: 'Add Races',
                component: AddRaces
            },
            {
                path: '/allnews/add',
                name: 'Add Allnews',
                component: AddAllnews
            },
            {
                path: '/education/add',
                name: 'Add Education',
                component: AddEducation
            },
            {
                path: '/users',
                name: 'Users',
                component: Users
            },
            {
                path: '/members',
                name: 'Members',
                component: Members
            },
            {
                path: '/member/athletes/:id',
                name: 'View Athletes',
                component: MemberAthletes
            },
            {
                path: '/static-page/add',
                name: 'Add Static Page',
                component: AddStaticPage
            },
            {
                path: '/job-posting/add-edit/',
                name: 'AddJob',
                component: JobPostingAddEdit
            },
            {
                path: '/user/add-edit/',
                name: 'Add User',
                component: AddEditUser
            },
            {
                path: '/category/add-edit/',
                name: 'Add Category',
                component: AddEditCategory
            },
            {
                path: '/category/add-edit/:id/:type',
                name: 'Edit Category',
                component: AddEditCategory
            },
            {
                path: 'race-applications/:id',
                name: 'RaceApplications',
                component: RaceApplications
            },
            {
                path: 'race-logs/:id',
                name: 'RaceLogs',
                component: RaceLogs
            },
            {
                path: 'race-applications/inspect/:id',
                name: 'RaceApplicationsInspect',
                component: RaceApplicationsInspect
            },
            {
                path: 'race-applications/edit/:id',
                name: 'RaceApplicationsEdit',
                component: RaceApplicationsEdit
            },
            {
                path: '/seasons/add-edit/',
                name: 'Add Season',
                component: AddEditRaceCategory
            },
            {
                path: '/seasons/add-edit/:id/:type',
                name: 'Edit Season',
                component: AddEditRaceCategory
            },
            {
                path: '/newcategory/add-edit/',
                name: 'Add Newcategory',
                component: AddEditNewcategory
            },
            {
                path: '/newcategory/add-edit/:id/:type',
                name: 'Edit Newcategory',
                component: AddEditNewcategory
            },
            {
                path: '/sub-board-categories/add-edit/',
                name: 'Add SubBoardCategories',
                component: AddEditSubBoardCategories
            },
            {
                path: '/sub-board-categories/add-edit/:id/:type',
                name: 'Edit SubBoardCategories',
                component: AddEditSubBoardCategories
            },
            {
                path: '/newsletter/send-bulk-email/',
                name: 'Send Bulk',
                component: SendBulkEmail
            },
            {
                path: '/newsletter/new-subscriber/',
                name: 'New Subscriber',
                component: NewSubscriber
            },
            {
                path: '/job-posting/add-edit/:id',
                name: 'EditJob',
                component: JobPostingAddEdit
            },
            {
                path: '/archive/edit/:id',
                name: 'Edit Archive',
                component: EditArchive
            },
            {
                path: '/user/add-edit/:id',
                name: 'Edit User',
                component: AddEditUser
            },
            {
                path: '/user/add-edit/:id/:type',
                name: 'Edit User',
                component: AddEditUser
            },
            {
                path: '/education/edit/:id',
                name: 'Edit Education',
                component: EditEducation
            },
            {
                path: '/page/edit/:id',
                name: 'Edit Page',
                component: EditPage
            },
            {
                path: '/news/edit/:id',
                name: 'Edit News',
                component: EditNews
            },
            {
                path: '/races/edit/:id',
                name: 'Edit Races',
                component: EditRaces
            },
            {
                path: '/coming-from-you/edit/:id',
                name: 'Edit ComingFromYou',
                component: EditComingFromYou
            },
            {
                path: '/allnews/edit/:id',
                name: 'Edit EditAllnews',
                component: EditAllnews
            },
            {
                path: '/news/gallery/:id',
                name: 'Edit News Gallery',
                component: EditNewsGallery
            },
            {
                path: '/leader/gallery',
                name: 'Edit Leader Gallery',
                component: EditLeaderGallery
            },
            {
                path: '/leader/pressgallery',
                name: 'Edit Press Gallery',
                component: EditPressGallery
            },
            {
                path: '/gallery',
                name: 'Edit Gallery',
                component: EditGallery
            },
            {
                path: '/video-gallery',
                name: 'Edit Video Gallery',
                component: EditVideoGallery
            },
            {
                path: '/allnews/gallery/:id',
                name: 'Edit Allnews Gallery',
                component: EditAllnewsGallery
            },
            {
                path: '/allnews/pdf/:id',
                name: 'Edit Allnews Pdf',
                component: EditAllnewsPdf
            },
            {
                path: '/news/pdf/:id',
                name: 'Edit News Pdf',
                component: EditNewsPdf
            },
            {
                path: '/leader/pdf/:id',
                name: 'Edit Leader Pdf',
                component: EditLeaderPdf
            },
            {
                path: '/leader/digital-press/pdf/:id',
                name: 'Edit Digital Press Pdf',
                component: EditDigitalPressPdf
            },
            {
                path: '/news/slider/:id',
                name: 'Edit News Slider',
                component: EditNewsSlider
            },
            {
                path: '/allnews/slider/:id',
                name: 'Edit Allnews Slider',
                component: EditAllnewsSlider
            },
            {
                path: '/leader/articles/slider/:id',
                name: 'Edit LeaderArticles Slider',
                component: EditLeaderArticlesSlider
            },
            {
                path: '/leader/articles/Gallery/:id',
                name: 'Edit LeaderArticles Gallery',
                component: EditLeaderArticlesGallery
            },
            {
                path: '/leader/digital-press/slider/:id',
                name: 'Edit DigitalPress Slider',
                component: EditDigitalPressSlider
            },
            {
                path: '/leader/digital-press/Gallery/:id',
                name: 'Edit DigitalPress Gallery',
                component: EditDigitalPressGallery
            },
            {
                path: '/static-page/edit/:id',
                name: 'Edit Static Page',
                component: EditStaticPage
            },
            {
                path: 'facilities',
                name: 'facilities',
                component: Facilities
            },
            {
                path: '/facilities/add',
                name: 'Add facilities',
                component: Addfacilities
            },
            {
                path: '/facilities/edit/:id',
                name: 'Edit facilities',
                component: Editfacilities
            },
            {
                path: 'homeboxes',
                name: 'homeboxes',
                component: Facilities
            },
            {
                path: 'activity-program-page',
                name: 'ActivityProgramPage',
                component: ActivityProgramPage
            },
            {
                path: 'information-banks-page',
                name: 'InformationBanksPage',
                component: InformationBanksPage
            },
            {
                path: '/homeboxes/add',
                name: 'Add homeboxes',
                component: Addhomeboxes
            },
            {
                path: '/activity-program-page/add',
                name: 'Add ActivityProgramPage',
                component: AddActivityProgramPage
            },
            {
                path: '/information-banks-page/add',
                name: 'Add InformationBanksPage',
                component: AddInformationBanksPage
            },
            {
                path: '/homeinfos/add',
                name: 'Add homeinfos',
                component: AddHomeInfos
            },
            {
                path: '/bank-informations/add',
                name: 'Add BankInformation',
                component: AddBankInformations
            },
            {
                path: '/leader/articles',
                name: 'LeaderArticles',
                component: LeaderArticles
            },
            {
                path: '/leader/articles/edit/:id',
                name: 'Edit LeaderArticles',
                component: EditLeaderArticles
            },
            {
                path: '/leader/articles/add',
                name: 'Add LeaderArticles',
                component: AddLeaderArticles
            },
            {
                path: '/announcements',
                name: 'Announcements',
                component: Announcements
            },
            {
                path: '/announcements/edit/:id',
                name: 'Edit Announcements',
                component: EditAnnouncements
            },
            {
                path: '/announcements/add',
                name: 'Add Announcements',
                component: AddAnnouncements
            },
            {
                path: '/activity-program',
                name: 'ActivityProgram',
                component: ActivityProgram
            },
            {
                path: '/activity-program/edit/:id',
                name: 'Edit ActivityProgram',
                component: EditActivityProgram
            },
            {
                path: '/activity-program/add',
                name: 'Add ActivityProgram',
                component: AddActivityProgram
            },
            {
                path: '/leader/digital-press',
                name: 'DigitalPress',
                component: DigitalPress
            },
            {
                path: '/leader/digital-press/edit/:id',
                name: 'Edit DigitalPress',
                component: EditDigitalPress
            },
            {
                path: '/leader/digital-press/add',
                name: 'Add DigitalPress',
                component: AddDigitalPress
            },
            {
                path: '/homeboxes/edit/:id',
                name: 'Edit homeboxes',
                component: Edithomeboxes
            },
            {
                path: '/activity-program-page/edit/:id',
                name: 'Edit ActivityProgramPage',
                component: EditActivityProgramPage
            },
            {
                path: '/information-banks-page/edit/:id',
                name: 'Edit InformationBanksPage',
                component: EditInformationBanksPage
            },
            {
                path: '/homeinfos/edit/:id',
                name: 'Edit homeinfos',
                component: EditHomeInfos
            },
            {
                path: '/bank-informations/edit/:id',
                name: 'Edit BankInformations',
                component: EditBankInformations
            },
            {
                path: '/cup-point-page',
                name: 'CupPointPage',
                component: CupPointPage
            },
            {
                path: '/cup-point-page/add',
                name: 'Add CupPointPage',
                component: AddCupPointPage
            },
            {
                path: '/cup-point-page/edit/:id',
                name: 'Edit CupPointPage',
                component: EditCupPointPage
            },
            {
                path: '/scores',
                name: 'Scores',
                component: Scores
            }
        ]
    },
    { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
 };**/

export default routes


// WEBPACK FOOTER //
// ./src/routes/routes.js